export default function getErrorDataMessage(errorData: unknown): string {
    if (typeof errorData === "string") {
        return errorData;
    }

    if (errorData instanceof Blob) {
        return "";
    }

    if (errorData && typeof errorData === "object") {
        try {
            return JSON.stringify(errorData);
        } catch {
            return "";
        }
    }

    return "";
}
